import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";
import swal from "sweetalert";
import { API_URL } from "../constant";
import Loader from "./loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $, { param, readyException } from 'jquery';
//import AllDataMemberTest from './all_data_member_test';


function AllDataMemberTreatment() {

  const navigat = useNavigate();

  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  $('#example').DataTable().destroy();

  $(document).ready(function () {

    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort']
      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
      responsive: true
    });
    var dt = $('#example').DataTable();
    dt.columns([1, 2, 3, 4]).visible(false);
  });
  /*********************get parameter from url*********************************** */
  const params = useParams();

  /******************************************************** */

  useEffect(() => {
    document.title = "All treatment data";
    getAllPatientData();
  }, [1]
  );
  /************Get all patient test list********************** */
  let getAllPatientData = async () => {
    const datas = { 'pid': params.pid };
    //  console.log(datas);
    const res = await axios.post(API_URL + 'admin/allPatientTreatmentData', datas)
      .then(ress => {
        //      console.log(ress.data);
        setUserData(ress.data.Rdata);
        setIsLoading(false);
      });
    //  console.log(res.data);
  }

  /***************** on click of mobile no************************************* */

  // let getTestResult =(pid,mob)=>{
  //   //return navigat('/patient_all_test_list/'+data+'/'+mob);
  // }
  /***************** Anm details************************************ */

  const getAnmDetails = (anm_id, patient_mob) => {
    return navigat('/anm_mediacal_team_user/' + anm_id + '/' + patient_mob);
  }

  /***************** Back************************************ */

  let backto = () => {
    return navigat('/ref_patient_all_test_list/' + params.pid + '/' + params.mob + '/' + params.name);
  }
  /****************************************** */

  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
          {isLoading ? (<Loader />) : (
            <>
              <div className="content-wrapper">
                <div className="row">


                  <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        {/* <h4 className="card-title">All treatment data of patient : {params.name} ( {params.pid} ) </h4><Link className="btn btn-outline-primary" to={'/all_data_member_test/'+params.pid+'/'+params.mob+'/'+params.name+'/'+params.typ+'/'+params.val}>Back</Link> */}
                        <h4 className="card-title">All treatment data of patient : {params.name}  </h4><Link className="btn btn-outline-primary" to={'/all_data_member_test/' + params.pid + '/' + params.mob + '/' + params.name + '/' + params.typ + '/' + params.val}>Back</Link>

                        <div className="table-responsive pt-3">
                          {/* <table className="table table-bordered display responsive nowrap" id="example"> */}
                          <table className="table table-bordered display  nowrap" id="example">
                            <thead>
                              <tr>
                                <th>  </th>
                                <th> Name </th>
                                <th>Patient ID</th>
                                <th>Associated Anm/RBSK/Nurse</th>
                                <th>Treatment given by Id</th>
                                <th>Treatment given by</th>
                                <th>Medician</th>
                                <th>Dose</th>
                                <th>Treatment data</th>
                                <th>Suggestion</th>
                                <th>Treatment started on</th>
                                <th>Follow up date</th>
                              </tr>
                            </thead>
                            <tbody>

                              {userData.map((udata, index) => (
                                //    <tr key={index}>
                                //    <td></td>	
                                //    {/* <td> {params.name}</td>	
                                //    <td> {udata.patient_id}</td>	 */}
                                //    {/* <td> <a href="#" onClick={()=>getAnmDetails(udata.treatment_given_by_id,params.mob)}>{udata.treatment_given_by_id}</a></td> */}
                                //    <td> <Link to={'/all_member_anm_medical_team/'+udata.treatment_given_by_id+'/'+params.mob+'/'+params.typ+'/'+params.val} >{udata.treatment_given_by_id }</Link></td>
                                //    <td> {udata.medician}</td>	
                                //    <td> {udata.dose}</td>	
                                //    <td> {udata.treatment_as_per_amb}</td>
                                //    <td> {udata.suggestion}</td>	
                                //    <td><Moment format="DD-MM-YYYY" >{udata.investigated_on}</Moment></td>
                                //    <td> {udata.follow_up_date }</td>

                                //  </tr>

                                <tr key={index}>
                                  <td></td>
                                  <td> {params.name}</td>
                                  <td> {udata.patient_id}</td>
                                  {/* <td> <a href="#" onClick={()=>getAnmDetails(udata.treatment_given_by_id,params.mob)}>{udata.treatment_given_by_id}</a></td> */}
                                  <td> <Link to={'/all_member_anm_medical_team/' + udata.treatment_given_by_id + '/' + params.mob + '/' + params.typ + '/' + params.val} >{udata.treatment_given_by_id}</Link></td>
                                  <td>{udata.treat_giv_by_id}</td>
                                  <td>{udata.treat_giv_by_name}</td>
                                  <td> {udata.medician}</td>
                                  <td> {udata.dose}</td>
                                  <td> {udata.treatment_as_per_amb}</td>
                                  <td> {udata.suggestion}</td>
                                  <td><Moment format="DD-MM-YYYY" >{udata.investigated_on}</Moment></td>
                                  <td> {udata.follow_up_date}</td>

                                </tr>
                              )
                              )}

                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <Footer />
            </>
          )}
        </div>

      </div>

    </div>);
}

export default AllDataMemberTreatment;